/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, FC } from "react";
import { useDropzone } from 'react-dropzone';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Box,
    Divider,
    IconButton,
    TableCell,
    TableRow,
    Tooltip,
    Table,
    TableHead,
    TableBody,
    Button,
    CircularProgress
  } from "@mui/material";
import api, { IDataRequest, STATUS_CODE, apiNoLoading } from "src/framework/providers/api";
import { notifierStore } from "src/framework/store/NotifierStore";
import { faRemove, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { Formater, TypeRecords } from "src/framework/commons/Formater";
import theme from "src/theme/light";
import { NFContaOrdem, Pedido } from "src/components/vendas/types";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import { DownloadUtil } from "src/framework/commons/DownloadUtil";
import { MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO } from "src/App";
import adminStore from "src/store/AdminStore";
import { LinearProgressBar } from "src/framework/components/commons/LinearProgressBar";
interface NotaFiscalContaOrdem {
    nota_fiscal_conta_ordem: {
      url: string;
    };
  }  
export interface EnviarNotaProperties {
    open: boolean;
    pedido: Pedido;
    idProjeto: number;
    onClose: () => void;
    onSuccess: ()=>void;
}

type UploadFileProperties = {
    anexo: AnexoFile,
    index: number;
    disabled?: boolean;
    onRemove: (index: number) => void;
}
export type AnexoFile = {
    index?: number;
    file?: File;
    previewName?: string | null;
    progress?: number
}

const UploadFile: FC<UploadFileProperties> = ({
    anexo,
    index,
    disabled = false,
    onRemove
}) => {
    const _anexo: AnexoFile = anexo;
    return <>
        <TableRow>
            <TableCell>
                {_anexo.previewName}
                <Tooltip title={String(_anexo.file?.name)}>
                    <span style={{ cursor: "help", marginLeft: "7px" }}>
                        <FontAwesomeIcon icon={faInfoCircle} color={theme.palette.grey[400]} />
                    </span>
                </Tooltip>
            </TableCell>
            <TableCell align="right">{Formater.toString((Number(_anexo?.file?.size || 0) / 1024), TypeRecords.DECIMAL2) + " Kb"}</TableCell>
            <TableCell width={120}>
                {_anexo.progress ? _anexo.progress > 99.9 ? "Ok" : <><LinearProgressBar progress={_anexo.progress} /></> : "Pendente"}
            </TableCell>
            <TableCell align="right">
                <IconButton size="small" style={{ color: theme.palette.error.main }} onClick={() => onRemove(index)} disabled={disabled}>
                    <FontAwesomeIcon icon={faRemove} size="sm" />
                </IconButton>
            </TableCell>
        </TableRow>
    </>
}

const EnviarNota: FC<EnviarNotaProperties> = ({
    open = true,
    idProjeto,
    pedido,
    onClose,
    onSuccess,
}) => {
    const [codigoProjeto, setCodigoProjeto] = useState<string>();
    const [uploading, setUploading] = useState<boolean>(false);
    const [anexoFile, setAnexoFile] = useState<AnexoFile>();
    const [notaFiscalContaOrdem, setNotaFiscalContaOrdem] = useState<NFContaOrdem>();

    const { getRootProps, getInputProps } = useDropzone({
        maxFiles: 1,
        onDropAccepted: (_files) => {
            const now: string = moment().format("YYYYMMDDHHmmss");
            const _anexo: AnexoFile = {
                index: 0,
                file: _files[0],
                previewName:`ARQ-NF-[CODIGO_PROJETO]-${now}`,
            }
            setAnexoFile(_anexo);
        },
        onDropRejected(fileRejections, event) {
            notifierStore.setNotifier({
                title: "Aviso!",
                content: "É permitida a inclusão de apenas 1 arquivo!",
                timeOut: 3500,
                onClose: () => {
                  notifierStore.setOpen(false)
                }
              })
              notifierStore.setOpen(true);
        },
    });
    const upload = async (): Promise<void> => {
        if(codigoProjeto){
            // verifica vigência substituição EV
            let vigencia = true
            if (idProjeto) {
                await adminStore.buscarProjeto(idProjeto, true).then(resp => {
                    if (!resp?.length) vigencia = false;
                });
            }
            if (!vigencia) return;

            try {
                if (anexoFile){
                    setUploading(true)
                    const _codVenda = codigoProjeto;
                    const url_update: string = `/vendas/pedidos/conta_ordem/nota_fiscal/${_codVenda}`
                    const url_post: string = `/vendas/pedidos/notas_fiscais/conta_ordem/uploads/${_codVenda}`;

                    const form = new FormData();
                    if (anexoFile.file){
                        const file = anexoFile.file;
                        const extension = anexoFile?.file?.name.split(".").pop();
                        const filename = `${anexoFile?.previewName?.replace("[CODIGO_PROJETO]",_codVenda)}.${extension}`;
                        form.append(filename, file, file.name);

                        const request: IDataRequest = {
                            url: url_post,
                            data: form,
                            headers: {
                                "Content-Type": "multipart/form-data",
                            },
                            onUploadProgress: (progressEvent: any) => {
                                const progress: number = Math.round(
                                    (progressEvent.loaded * 100) / progressEvent.total
                                )
                                anexoFile.progress = progress;
                                setAnexoFile(anexoFile);
                            }
                        }
                        const response = await apiNoLoading.post(request);
                
                        if (response.statusCode === STATUS_CODE.OK) {
                            const path = response.data[filename].path;
                            const data: NotaFiscalContaOrdem = {
                                nota_fiscal_conta_ordem: {
                                url: path
                                }
                            };
                            const _request: IDataRequest = {
                                url: url_update,
                                data: data
                            }
                            const _response = await apiNoLoading.put(_request);
                            if (_response.statusCode === STATUS_CODE.OK){
                                notifierStore.setNotifier({
                                    title: "Aviso!",
                                    content: "Nota Fiscal de Venda enviada com sucesso!",
                                    timeOut: 3500,
                                    onClose: () => {
                                        notifierStore.setOpen(false)
                                        onSuccess();
                                        onClose();
                                    }
                                })
                                notifierStore.setOpen(true);
                            } else {
                                notifierStore.setNotifier({
                                    title: "Atenção!",
                                    content: response.message,
                                    timeOut: 3500,
                                    onClose: () => {
                                        notifierStore.setOpen(false);
                                        if (response?.message?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO)) {
                                            window.location.href = `${window.location.origin}/projetos/menu-projetos`;
                                        }
                                    }
                                });
                                notifierStore.setOpen(true); 
                            }
                        } else {
                            notifierStore.setNotifier({
                                title: "Atenção!",
                                content: response.message,
                                timeOut: 3500,
                                onClose: () => {
                                    notifierStore.setOpen(false);
                                    if (response?.message?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO)) {
                                        window.location.href = `${window.location.origin}/projetos/menu-projetos`;
                                    }
                                }
                            });
                            notifierStore.setOpen(true); 
                        }
                    }
                    setAnexoFile(undefined)
                }

            } catch (error) {

            } finally {
                setUploading(false);
            }
        }
    }
    const loadCodProjeto = async()=>{
        if (idProjeto){
            const request: IDataRequest = {
                url: `/projetos?id=${idProjeto}`
            }
            const response = await apiNoLoading.get(request)
            if(response.statusCode === STATUS_CODE.OK){
                const cod_venda = response.data[0].codigo_venda;
                setCodigoProjeto(cod_venda);
            } else {
                const message: string[] = Array.isArray(response?.message) ? response?.message : [response?.message];
                const mensagemVigencia = message?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO) || message?.some(m => m?.includes(MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO));
                if (mensagemVigencia) {
                    notifierStore.setNotifier({
                        title: "Aviso!!!",
                        content: [MENSAGEM_VIGENCIA_SUBSTITUICAO_CONTA_ENCERRADO],
                        timeOut: 3500,
                        onClose: () => {
                            notifierStore.setOpen(false);
                        }
                    });
                    notifierStore.setOpen(true);
                }
            }
        }
    }

    useEffect(()=>{
        loadCodProjeto();
    },[idProjeto]);

    useEffect(()=>{
        if (pedido?.nota_fiscal_conta_ordem) {
            setNotaFiscalContaOrdem(pedido?.nota_fiscal_conta_ordem);
        }
    },[pedido, codigoProjeto]);

    const doDownload = async (): Promise<void> => {
        const request: IDataRequest = {
            url: `/vendas/pedidos/notas_fiscais/conta_ordem/uploads?pedido_id=${pedido?.id}`,
        }

        const response = await api.getFile(request);
        if (response?.statusCode === STATUS_CODE.OK && response?.data) {
            DownloadUtil.zip(response.data, codigoProjeto + "-ARQ-NF-Venda");
        } else {
            if (response?.message) {
                notifierStore.setNotifier({
                    title: "Aviso!!!",
                    content: response?.message,
                    timeOut: 3000,
                    onClose: () => {
                        notifierStore.setOpen(false);
                    }
                });
                notifierStore.setOpen(true);
            }
        }
    }

    return (<>
        
        <Box
            style={{width: "1400px"}}
        >
            <Dialog 
                open={open}
                maxWidth={'md'}
            >
                <DialogTitle id="dialog-enviar-nota">
                    <h3>Nota Fiscal de Venda</h3>
                    <Divider />
                </DialogTitle>
                <DialogContent>
                    <section className="container">
                        <div {...getRootProps({ className: 'dropzone' })} style={{
                            display: "flex",
                            height: "100px",
                            color: `${theme.palette.grey[500]}`,
                            border: `dotted 2px ${theme.palette.grey[500]}`,
                            background: `${theme.palette.grey[300]}`,
                            borderRadius: theme.shape.borderRadius,
                            textAlign: "center",
                            alignContent: "center",
                            alignItems: "center",
                            justifyItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            }}>
                            <input {...getInputProps()} accept=".pdf" />
                            <Box style={{padding: "0px 15px"}} display={"flex"} maxWidth={"md"}>
                                <p style={{ fontSize:"16px", color: "red"}}>*</p>
                                <p style={{ fontSize:"16px", color: "black" }}>Clique aqui para carregar um arquivo ou arraste e solte aqui um arquivo.</p>
                            </Box>
                        </div>
                        {
                            anexoFile ? <>
                            <aside>
                                <h4>Arquivo</h4>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Arquivo</TableCell>
                                            <TableCell align="right">Tamanho</TableCell>
                                            <TableCell>Situação</TableCell>
                                            <TableCell align="right"></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <UploadFile
                                            key={`upload-${anexoFile.index}`}
                                            anexo={anexoFile}
                                            index={anexoFile.index || 0}
                                            disabled={uploading}
                                            onRemove={()=>{
                                                setAnexoFile(undefined);
                                            }}
                                        />
                                    </TableBody>
                                </Table>
                            </aside>
                            </>:""}
                            {(notaFiscalContaOrdem && !anexoFile) ? <>
                                <aside>
                                    <Table style={{ marginBottom: 10 }} size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Arquivo</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>
                                                    {`ARQ-NF-${codigoProjeto}-${moment(notaFiscalContaOrdem.created_at).format("YYYYMMDDHHmmss")}`}
                                                    <Tooltip title={String(notaFiscalContaOrdem?.url)}>
                                                        <span style={{ cursor: "help", marginLeft: "7px" }}>
                                                            <FontAwesomeIcon icon={faInfoCircle} color={theme.palette.grey[400]} />
                                                        </span>
                                                    </Tooltip>
                                                </TableCell>                       
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </aside>
                            </> : ""}
                    </section>
                </DialogContent>
                <DialogActions>
                    <Button
                        disabled={uploading}
                        onClick={() => {
                            onClose();
                            setAnexoFile(undefined);
                        }}
                        color="secondary">
                        Cancelar
                    </Button>
                    {(notaFiscalContaOrdem && !anexoFile) && (
                        <FlatButton
                            color="secondary"
                            variant="contained"
                            text="Baixar Arquivo"
                            onClick={doDownload}
                        />
                    )}
                    <Button
                        onClick={() => {
                            upload();
                        }}
                        disabled={!anexoFile}
                        color="primary" variant="contained" disableElevation>
                        {uploading ? <><CircularProgress variant="indeterminate" size={20} /></> : "Carregar"}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    </>
    )
};
export { EnviarNota };